// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"587":"9f933417","976":"6e9906f1"}[chunkId] + ".css";
};